export default "__VITE_ASSET__C$FUEF$4__"